import { Attribute } from "../../types/prodcatBaseTypes";
import { getAttributeValues } from "./getAttributeValues";

export const getAttributeValuesFromHierarchy = (
  key: string,
  productAttributes: Attribute[],
  variantAttributes: Attribute[],
): string[] => {
  const variantValues = getAttributeValues(key, variantAttributes);
  const productValues = getAttributeValues(key, productAttributes);

  if (variantValues.length > 0) {
    return variantValues;
  } else {
    return productValues;
  }
};
